/**
 * QUNTO geo market popup — suggest detected country, confirm or choose another (Shopify Markets).
 */
(function () {
  const STORAGE_KEY = 'qunto_geo_market_v1';

  /** @returns {{ code: string, expires: number } | null} */
  function readStoredChoice() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (!data || typeof data.expires !== 'number' || data.expires <= Date.now()) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch {
      return null;
    }
  }

  /** @param {string} code */
  function saveChoice(code) {
    const root = document.getElementById('regional-store-popup-root');
    const days = parseInt(root?.dataset.dismissDays || '30', 10);
    const ttl = Math.max(1, days) * 24 * 60 * 60 * 1000;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ code, expires: Date.now() + ttl }));
    } catch {
      /* private browsing */
    }
  }

  /** @returns {{ code: string, name: string }[]} */
  function readCountries() {
    const el = document.getElementById('geo-market-countries-json');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || '[]');
    } catch {
      return [];
    }
  }

  /** @param {string} rootPath */
  async function fetchDetectedCountry(rootPath) {
    const url = `${rootPath}browsing_context_suggestions.json`;
    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) return null;
      const data = await res.json();
      const handle = data?.detected_values?.country?.handle;
      const name = data?.detected_values?.country?.name;
      if (typeof handle === 'string' && handle.length) {
        return { code: handle.toUpperCase(), name: name || handle };
      }
    } catch {
      /* offline / blocked */
    }
    return null;
  }

  /** @param {HTMLDialogElement} dialog */
  function openDialog(dialog) {
    if (dialog.open) return;

    const scrollY = window.scrollY;
    dialog.dataset.scrollY = String(scrollY);

    requestAnimationFrame(() => {
      document.body.style.width = '100%';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      dialog.showModal();
      dialog.classList.add('regional-store-popup--open');
    });
  }

  /** @param {HTMLDialogElement} dialog */
  function closeDialog(dialog) {
    if (!dialog.open) return;

    dialog.classList.remove('regional-store-popup--open');
    dialog.classList.add('regional-store-popup--closing');

    const finish = () => {
      dialog.close();
      dialog.classList.remove('regional-store-popup--closing');
      const scrollY = parseInt(dialog.dataset.scrollY || '0', 10);
      document.body.style.width = '';
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, scrollY);
    };

    dialog.addEventListener('animationend', finish, { once: true });
    window.setTimeout(finish, 400);
  }

  /**
   * @param {HTMLElement} root
   * @param {string} countryName
   */
  function setHeading(root, countryName) {
    const heading = document.getElementById('regional-store-popup-heading');
    const template = root.dataset.headingTemplate || 'Shop in __COUNTRY__?';
    if (heading) {
      heading.textContent = template.replace('__COUNTRY__', countryName);
    }
  }

  /** @param {HTMLFormElement} form @param {string} code */
  function submitCountry(form, code) {
    const input = form.querySelector('[data-geo-country-input]');
    const select = form.querySelector('[data-geo-country-select]');
    if (input) input.value = code;
    if (select) select.value = code;
    form.submit();
  }

  async function init() {
    const root = document.getElementById('regional-store-popup-root');
    const dialog = document.getElementById('regional-store-popup');
    const form = document.getElementById('geo-market-popup-form');
    if (!root || !dialog || !form) return;

    const currentCode = (root.dataset.currentCode || '').toUpperCase();
    const stored = readStoredChoice();
    if (stored && stored.code === currentCode) return;

    const countries = readCountries();
    const byCode = new Map(countries.map((c) => [c.code.toUpperCase(), c.name]));

    const rootPath = window.Shopify?.routes?.root || '/';
    const detected = await fetchDetectedCountry(rootPath);

    let suggestedCode = currentCode;
    let suggestedName = root.dataset.currentName || currentCode;

    if (detected && byCode.has(detected.code)) {
      suggestedCode = detected.code;
      suggestedName = byCode.get(detected.code) || detected.name || suggestedCode;
    }

    setHeading(root, suggestedName);

    const hiddenInput = form.querySelector('[data-geo-country-input]');
    const select = form.querySelector('[data-geo-country-select]');
    if (hiddenInput) hiddenInput.value = suggestedCode;
    if (select) select.value = suggestedCode;

    const confirmBtn = root.querySelector('[data-geo-confirm]');
    const toggleBtn = root.querySelector('[data-geo-toggle-picker]');
    const applyBtn = root.querySelector('[data-geo-apply]');
    const picker = root.querySelector('[data-geo-picker]');

    confirmBtn?.addEventListener('click', () => {
      if (suggestedCode === currentCode) {
        saveChoice(currentCode);
        closeDialog(dialog);
        return;
      }
      saveChoice(suggestedCode);
      submitCountry(form, suggestedCode);
    });

    toggleBtn?.addEventListener('click', () => {
      if (!picker || !toggleBtn) return;
      const open = picker.hidden;
      picker.hidden = !open;
      toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    applyBtn?.addEventListener('click', () => {
      const code = (select?.value || suggestedCode).toUpperCase();
      saveChoice(code);
      if (code === currentCode) {
        closeDialog(dialog);
        return;
      }
      submitCountry(form, code);
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) event.preventDefault();
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
    });

    root.hidden = false;
    openDialog(dialog);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
